export const MIN_2_IMAGES_ERR =
  '[InstagramPublisher] - Minimum 2 images required';

export const MAX_10_IMAGES_ERR =
  '[InstagramPublisher] - Maximum 10 images allowed';

export const IMAGES_NOT_FOUND_ERR =
  '[InstagramPublisher] - Not all images found';

export const THUMBNAIL_NOT_FOUND_ERR =
  '[InstagramPublisher] - Thumbnail image not found';

export const THUMBNAIL_NOT_JPG_ERR =
  '[InstagramPublisher] - Thumbnail image is not .jpg';

export const VIDEO_NOT_FOUND_ERR = '[InstagramPublisher] - Video not found';

export const IMAGES_NOT_JPG_ERR =
  '[InstagramPublisher] - Only .jpg images are allowed';

export const IMAGES_WRONG_ASPECT_RATIO_ERR =
  '[InstagramPublisher] - Not all images have 1:1 aspect ratio';

export const LOGIN_ERR = '[InstagramPublisher] - Invalid credentials';

export const LOGIN_ERR_COOKIES =
  '[InstagramPublisher] - No coookies found after login';

export const CAPTION_TOO_LONG_ERR =
  '[InstagramPublisher] - Caption should not exceed 2200 characters';

export const INVALID_VIDEO_FORMAT =
  '[InstagramPublisher] - Only .mp4 video files are supported';

export const INVALID_VIDEO_ASPECT_RATIO = `[InstagramPublisher] - Only '1:1', '16:9', '9:16' video aspect ratios are supported`;
export const LOCATION_NOT_FOUND = `[InstagramPublisher] - Location not found`;
